/**
 * Created by vsliwka on 20/04/2017.
 */
export class WorkVersionArticleModel {
  public id: number = null;
  public label: string;
  public isoCode: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
